// extracted by mini-css-extract-plugin
export default {"root":"PhotoReports_root__VWxVF","breadcrumb":"PhotoReports_breadcrumb__08GEM","content":"PhotoReports_content__rzTJx","container":"PhotoReports_container__u7CFf"};